import z from 'zod';

export type CarbonDioxideDisplayLabelDto = {
	label: string;
	color: string;
};

export const CarbonDioxideDisplayLabelDtoSchema: z.ZodType<CarbonDioxideDisplayLabelDto> = z.object(
	{
		label: z.string(),
		color: z.string(),
	}
);
